import { useSuspenseQuery } from '@apollo/client'
import { FetchGoalConfigsDocument } from '@salescore/client-api'
import { getOrganizationIdFromPath, useCan } from '@salescore/client-common'
import { UpdateGoalConfigForm } from '@salescore/client-feature-setting'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

//
// 目標入力のページ
//
const Page = (): ReactNode => {
  // 大したレコード数にならない想定なので、全取得している
  const {
    data: { goalConfigs },
    refetch,
  } = useSuspenseQuery(FetchGoalConfigsDocument, {
    variables: {
      organizationId: getOrganizationIdFromPath(),
    },
    fetchPolicy: 'cache-and-network',
  })
  const { organizationId, goalConfigId } = Route.useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const canManageGoal = useCan('manage-goal')

  if (!canManageGoal) {
    return <div>{t(`設定権限がありません。`)}</div>
  }

  const goalConfig = goalConfigs.find((x) => x.id === goalConfigId)

  if (goalConfig === undefined) {
    return <div>{t(`目標が見つかりません`)}</div>
  }

  if (goalConfig.dashboardView === undefined) {
    return <div>{t(`この目標が紐づいていたダッシュボードが削除されました。`)}</div>
  }

  return (
    <div>
      <UpdateGoalConfigForm
        goalConfig={goalConfig}
        onBack={() => {
          void navigate({
            to: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId',
            params: { organizationId, goalConfigId: goalConfig.id },
          })
        }}
        onAfterFinish={() => {
          void refetch()
          void navigate({
            to: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId',
            params: { organizationId, goalConfigId: goalConfig.id },
          })
        }}
      />
    </div>
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit')({
  component: Page,
})
